import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import createReactClass from 'create-react-class';
import { EmitEvent, EmitGoogleTagManagerConversionEvent } from './analyticsEvents';
import { runMarketingPipeline } from './pipeline/marketing';
import { readSessionFromStorage, readSessionFromUrl } from './lead';
import { isNumber, isString, isUndefined } from 'lodash-es';

const leadUtils = require('form/lead');

const LEADBOX_DEBUG_URL = 'https://6kjp18m3m7.execute-api.eu-central-1.amazonaws.com/test/leads';

export default function (properties) {
  const { config, tools, leadUuid } = properties;

  function getLeadboxUrl(state) {
    const ajaxUrlFromTabs = tools.findStateProperties(state, '_ajaxUrl')[0];

    if (ajaxUrlFromTabs === '') {
      return null;
    }

    return window.location.href.includes('localhost') ? LEADBOX_DEBUG_URL : config.ajaxUrl;
  }

  function getEventLabel() {
    return config?.eventLabel ? config.eventLabel : 'submit';
  }

  return async function post(state, additionalProps) {
    const legacyData = leadUtils.generateLegacyLead(state);
    const leadboxData = leadUtils.generateLead(state);

    /** Check for customEvent configuration in state. */
    const gtmEvent = tools.findStateProperties(state, 'gtmEvent');

    const email = state.globalState?.email;
    const phone = state.globalState?.phone_international_format;

    /** Emit Google Tag Manager event upon conversion. */
    gtmEvent && gtmEvent.length > 0
      ? await EmitGoogleTagManagerConversionEvent(gtmEvent[0], { guid: leadUuid, phone, email })
      : await EmitGoogleTagManagerConversionEvent(undefined, { guid: leadUuid, phone, email });

    const utms = readSessionFromStorage();

    const { recaptchaToken, recaptchaScore, smsVerified } = additionalProps;

    leadboxData.guid = leadUuid;
    leadboxData.marketing = await runMarketingPipeline();
    leadboxData.utm = Object.keys(utms).length > 0 ? utms : readSessionFromUrl();

    leadboxData.meta = {
      ...(config.leazard_config_name ? { leazard_config_name: config.leazard_config_name } : {}),
      // We only include smsVerified field when phone verification is active in the form.
      ...(!isUndefined(smsVerified) ? { sms_verified: smsVerified } : {}),
      ...(isString(recaptchaToken) ? { recaptcha_token: recaptchaToken } : {}),
      ...(isNumber(recaptchaScore) ? { recaptcha_score: recaptchaScore } : {}),
    };

    postJSON(getLeadboxUrl(state), leadboxData, function (value) {
      sendGoogleAnalyticEvent(function () {
        callIframeTalker(state, config, function (postUrl) {
          render(legacyData, value, postUrl, leadboxData);
        });
      }, getEventLabel());
    });
  };

  function makeHiddenForm() {
    return createReactClass({
      formRef: React.createRef(),
      render() {
        const target = config.postTarget || '_self';
        return (
          <form
            ref={this.formRef}
            style={{ display: 'none' }}
            action={this.props.postUrl}
            target={target}
            method="POST"
          >
            {this.makeFields(this.props.fields)}
          </form>
        );
      },
      makeFields(fields) {
        if (config.nospam.aux_user_id)
          return (this.makeInputs(fields) || []).concat(
            this.makeInput(config.nospam.aux_user_id.name, -1, this.props.aux_user_id)
          );
        else return this.makeInputs(fields);
      },
      makeInputs(fields) {
        let f = Object.keys(fields).map((key) => {
          const value = fields[key];
          if (Array.isArray(value)) {
            return this.makeInputList(value, key);
          } else return this.makeInput(key, key, value);
        });

        // Add leazard data as well
        if (config && config.kvittering) {
          let lbData = JSON.stringify(this.props.leadboxData);
          lbData = lbData
            .replace('\n', '\\n')
            .replace('\r', '\\r')
            .replace('\t', '\\t')
            .replace('\b', '\\b')
            .replace('\f', '\\f');
          f.push(this.makeInput('leadboxData', 'leadboxData', lbData));
        }

        return f;
      },
      makeInput(name, key, value) {
        return <input key={key} name={name} value={value} readOnly />;
      },
      makeInputList(list, name) {
        return list.map((checkbox, index) => {
          return this.makeInput(name + '[]', name + index, checkbox);
        });
      },
      componentDidMount() {
        if (this.formRef.current) {
          this.formRef.current.submit();
        }
      },
    });
  }

  function render(combined, awsStats = {}, url, leadboxData) {
    const postUrl = url || config.postUrl;

    if (postUrl) {
      const container = document.getElementById('hidden-form');
      const root = createRoot(container);

      if (config && config.kvittering) {
        root.render(
          React.createElement(makeHiddenForm(), {
            fields: tools.merge(combined, makeSysTime(awsStats)),
            aux_user_id: awsStats['aws-response'],
            postUrl: postUrl,
            leadboxData,
          })
        );
      } else {
        root.render(
          React.createElement(makeHiddenForm(), {
            fields: tools.merge(combined, makeSysTime(awsStats)),
            aux_user_id: awsStats['aws-response'],
            postUrl: postUrl,
          })
        );
      }
    }
  }

  function postJSON(url = null, data, callback) {
    let happenedOnce = false;

    function resolve(value) {
      if (happenedOnce) return;
      else {
        happenedOnce = true;
        callback(value);
      }
    }

    if (url === null) resolve({});
    else {
      if (config && config.kvittering) {
        resolve();
      } else {
        postAjax(url, data, resolve);
      }
    }

    async function postAjax(url, data, resolve) {
      const startingTime = Date.now();

      if (typeof $ !== 'undefined') {
        /**
         * Add Google Analytics client_id
         * to payload for AWS post
         */
        try {
          const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
          });

          success(startingTime, resolve, response);
        } catch (e) {
          error(resolve, e);
        }
      }
    }

    function error(resolve, err) {
      const errors = {
        error: err.responseText || err,
      };

      resolve(errors);
    }

    function success(startingTime, resolve, response) {
      try {
        resolve(parse(startingTime, response));
      } catch (error) {
        resolve({
          error: 'Ajax post response was unparsable',
        });
      }
    }

    function parse(startingTime, response) {
      return {
        'aws-roundtrip': Date.now() - startingTime,
        'aws-response': JSON.parse(response),
      };
    }
  }

  async function sendGoogleAnalyticEvent(callback, eventLabel) {
    let formSubmitted = false;

    function submitForm() {
      if (!formSubmitted) {
        formSubmitted = true;
        callback();
      }
    }

    try {
      await EmitEvent({ eventCategory: 'Skjema', eventAction: 'lead', eventLabel });
    } catch (e) {}

    setTimeout(submitForm, 1000);
  }

  function makeSysTime(data) {
    const appInfo = {
      appVersion: navigator.appVersion,
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      url: window.location.href,
    };
    const nospam = config.nospam;
    if (!nospam.sys_times) return {};
    return {
      [nospam.sys_times.name]: JSON.stringify(tools.merge(appInfo, data)),
    };
  }

  function callIframeTalker(state, config, callback) {
    const postUrl = tools.findStateProperties(state, 'postUrl')[0] || config.postUrl;
    let called = false;

    function calledOnce(url = postUrl) {
      if (called) return;
      else {
        called = true;
        callback(url);
      }
    }

    if (window.iframetalker && window.iframetalker.submit) {
      setTimeout(calledOnce, 1000);
      const iframeReceipt = tools.findStateProperties(state, 'postUrl')[0] || config.postUrl;
      window.iframetalker.submit(function (urlAddition) {
        const containsQuery = urlWithQuery(iframeReceipt);
        const query = urlAddition.query || {};
        const submitUrl = Object.keys(query).reduce((url, key, index) => {
          if (index === 0 && !containsQuery) url += '?' + key + '=' + query[key];
          else url += '&' + key + '=' + query[key];
          return url;
        }, iframeReceipt);
        calledOnce(submitUrl);
      });
    } else {
      calledOnce();
    }

    function urlWithQuery(url) {
      return String(url).indexOf('?') !== -1;
    }
  }
}
